import React from 'react';
import PropTypes from 'prop-types';

export const FixturePrematchLabel = ({ prematchLabel, isFinals }) => {
    return (
        <div
            className={`fixtures__badge fixtures__badge--prematch-label${
                isFinals ? '--finals' : ''
            }`}
        >
            <p className="fixtures__badge-text">{prematchLabel}</p>
        </div>
    );
};

FixturePrematchLabel.propTypes = {
    prematchLabel: PropTypes.string,
    isFinals: PropTypes.bool
};
